module.exports = __webpack_public_path__ + "static/media/card-mastercard.a429bc16.svg";